import { type FC, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { MediaLibraryStore } from 'widgets/MediaLibrary/store/mediaLibraryStore'
import { useMessageFieldContext } from 'widgets/MessageField/context/MessageFieldContext'
import {
  type IMediaLibraryStoreProps,
  MediaLibrarySelectMode,
  MediaLibraryVariant,
} from 'widgets/MediaLibrary/types/types'
import { usePresentationModeContext } from 'widgets/PresentationMode'
import styles from './styles.module.scss'

type MediaLibraryMessageFieldButtonProps = {
  onClick: () => void
}

export const MediaLibraryMessageFieldButton: FC<MediaLibraryMessageFieldButtonProps> = observer(
  ({ onClick }) => {
    const messageFieldStore = useMessageFieldContext()
    const entities = useEntitiesContext()
    const presentationStore = usePresentationModeContext()
    const mediaLibraryConfiguration: IMediaLibraryStoreProps = {
      mediaLibraryVariant: MediaLibraryVariant.MessageField,
      onAddAttachment: messageFieldStore.addAttachment,
      selectMode: MediaLibrarySelectMode.Multiple,
      messageFieldStore,
    }

    const [store] = useState(
      () => new MediaLibraryStore(mediaLibraryConfiguration, entities, presentationStore)
    )

    return (
      <Button
        text='View all'
        typeBtn='text'
        size='small'
        className={styles.accessLibraryButton}
        onClick={() => {
          store.handleOpenMediaLibraryModal()
          onClick()
        }}
      />
    )
  }
)
